export default __webpack_public_path__ + "static/media/infra-1.9f5af360.webp";